/**
 * Navigate helper that allows us to redirect to any page
 * as an alternative to router.push, when necessary
 *
 * @param {object} opts
 * @param {string} opts.navigateUrl
 * @param {object} [opts.query]
 * @returns {string}
 */
const navigateHelper = (opts = {}) => {
  if (!opts.navigateUrl) {
    return '';
  }
  const { navigateUrl, query } = opts;

  if (query) {
    const queryParams = Object.keys(query);
    const queryString = queryParams
      .map(key => key + '=' + query[key])
      .join('&');
    return (location.href = location.origin + navigateUrl + '?' + queryString);
  }

  return (location.href = location.origin + navigateUrl);
};

export default navigateHelper;
